'use es6';

import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import { getApiClient } from '../utils/apiClient';
let apiBase = 'ecosystem/v1';
const adminApiBase = 'ecosystem/admin/v1';
export const setApiBase = base => {
  apiBase = base;
};
export const getAppIntegrations = () => {
  return getApiClient().get(`${apiBase}/apps/tags/app-integrations`);
};
export const searchApps = ({
  language,
  queries,
  showPreferredLanguageFirst = false
}, opts = {}) => {
  return getApiClient().post(`${apiBase}/apps/search`, Object.assign({}, opts, {
    data: {
      language,
      showPreferredLanguageFirst,
      queries
    }
  }));
};
export const details = (slug, language) => getApiClient().get(`${apiBase}/apps/details`, {
  query: {
    slug,
    language
  }
});
export const detailsPreview = (slug, language, base = apiBase) => getApiClient().get(`${base}/apps/details/preview`, {
  query: {
    slug,
    language
  }
});
export const detailsAdminPreview = (slug, language) => detailsPreview(slug, language, adminApiBase);
export const fetchInstallability = offeringId => getApiClient().get(`${apiBase}/apps/${offeringId}/installability`);
export const fetchCompatibility = () => getApiClient().get(`${apiBase}/compatibility/ops-hub`);
export const emailAdmin = (adminUserId, listingId, permissions) => {
  return getApiClient().post(`${apiBase}/permissions/request-from-admin`, {
    data: {
      adminUserId,
      listingId,
      permissions
    }
  });
};
export const fetchReviews = queries => {
  return getApiClient().post(`${apiBase}/reviews/search`, {
    data: Object.assign({
      reviewTypes: [ReviewTypes.APP]
    }, queries)
  });
};
export const fetchReviewsStats = offeringId => getApiClient().post(`${apiBase}/reviews/stats`, {
  data: {
    entityId: offeringId,
    reviewType: ReviewTypes.APP
  }
});
export const writeReview = review => {
  return getApiClient().post(`${apiBase}/reviews`, {
    data: review
  });
};
export const toggleReviewHelpful = (reviewId, isHelpful) => getApiClient().put(`${apiBase}/reviews/${reviewId}/helpful`, {
  data: isHelpful
});